import { createPopper } from "@popperjs/core"
import localeEn from "../modules/air-datepicker/en"
import moment from "moment"

let searchBar
let arrivalDateInput
let datePickerInstance
let bookingType
let bookingTypeField
const allowedCheckinDays = ["Friday", "Saturday", "Monday"]
const CAMPING = 0
const ACCOMMODATION = 1

function watchBookingTypeForChange() {
  if (bookingTypeField) {
    bookingTypeField.addEventListener("change", (event) => {
      bookingType = event.target.value
      regenerateDatePicker()
      if (bookingType == ACCOMMODATION) {
        updateArrivalDateAccommodation()
        updateNightsSelectorAccommodation()
      } else if (bookingType == CAMPING) {
        updateArrivalDateCamping()
        updateNightsSelectorCamping()
      }
    })
  }
}

function updateNightsSelectorAccommodation() {
  const nightsSelector = searchBar.querySelector("#select-no_of_nights")
  const selectedDayName = getDayName(datePickerInstance.selectedDates[0])

  const currentValue = parseInt(nightsSelector.value)

  let stayLength
  switch (selectedDayName) {
    case "Friday":
      stayLength = 3
      break
    case "Saturday":
      stayLength = 2
      break
    case "Monday":
      stayLength = 4
      break
  }

  const urlParams = new URLSearchParams(window.location.search)
  const queryParamNights = parseInt(urlParams.get("no_of_nights"))

  nightsSelector.querySelectorAll("option").forEach((option) => {
    option.classList.remove("hidden")
    option.removeAttribute("disabled")
    option.removeAttribute("selected")

    const optionValue = parseInt(option.value)

    if (optionValue !== stayLength && optionValue !== 7) {
      option.classList.add("hidden")
      if (optionValue == 3 || optionValue == 2 || optionValue == 4) {
        option.setAttribute("disabled", "")
        option.classList.remove("hidden")
      }
    }
    if (optionValue == stayLength && queryParamNights !== 7 && currentValue !== 7) {
      option.setAttribute("selected", "")
    }
    if (queryParamNights == 7 && optionValue == 7) {
      option.setAttribute("selected", "")
    }
  })
}

function updateNightsSelectorCamping() {
  const nightsSelector = searchBar.querySelector("#select-no_of_nights")
  nightsSelector.querySelectorAll("option").forEach((option) => {
    option.classList.remove("hidden")
    option.removeAttribute("disabled")
  })
}

function updateArrivalDateAccommodation() {
  initialiseDatePicker(arrivalDateInput)
}

function updateArrivalDateCamping() {
  initialiseDatePicker(arrivalDateInput)
}

function searchBarOnPage() {
  return document.querySelector(".searchBarContainer")
}

window.addEventListener("livewire:navigated", (event) => {
  if (searchBarOnPage()) {
    regenerateDatePicker()
    if (bookingType == ACCOMMODATION) {
      updateArrivalDateAccommodation()
      updateNightsSelectorAccommodation()
    } else if (bookingType == CAMPING) {
      updateArrivalDateCamping()
      updateNightsSelectorCamping()
    }
    watchBookingTypeForChange()
  }
})

function desktopOrMobile() {
  const desktopContainer = document.querySelector(".searchBarContainer")
  const mobileContainer = document.querySelector(".searchBarMobile")
  if (desktopContainer) {
    searchBar = desktopContainer
  }
  if (mobileContainer) {
    searchBar = mobileContainer
  }

  bookingTypeField = searchBar.querySelector("#select-booking_type")
  bookingType = parseInt(bookingTypeField.value)
}

function regenerateDatePicker() {
  desktopOrMobile()
  arrivalDateInput = document.querySelector(".searchBarDateInput")
  arrivalDateInput.replaceWith(arrivalDateInput.cloneNode(false))
  arrivalDateInput = document.querySelector(".searchBarDateInput")
}

function findAltField(inputField) {
  const uniqueInputId = inputField.dataset.uuid
  return document.querySelector("." + uniqueInputId)
}

function getStartDate(altField) {
  if (altField.dataset.selected_date && bookingType !== ACCOMMODATION && !allowedCheckinDays.includes(dayName)) {
    return Date.parse(altField.dataset.selected_date)
  }

  const today = new Date()
  let currentDate = today

  if (altField.dataset.selected_date) {
    currentDate = new Date(altField.dataset.selected_date)
  }

  if (datePickerInstance) {
    if (datePickerInstance?.selectedDates.length > 0 && datePickerInstance?.selectedDates[0]) {
      currentDate = datePickerInstance.selectedDates[0]
    }
  }

  let dayName = getDayName(currentDate)
  if (bookingType == ACCOMMODATION && !allowedCheckinDays.includes(dayName)) {
    while (!allowedCheckinDays.includes(dayName)) {
      currentDate.setDate(currentDate.getDate() + 1)
      dayName = getDayName(currentDate)
    }
  }

  return currentDate
}

function parseDays(altField) {
  return parseInt(altField.dataset.days_to_add.split("+")[1].split(" ")[0]) ?? 0
}

function initialiseDatePicker(input) {
  const field = input
  const altField = findAltField(input)
  const fieldDateFormat = "dd-MM-yyyy"
  const altFieldDateFormat = altField.dataset.date_format ?? fieldDateFormat
  const startDate = getStartDate(altField)
  altField.value = moment(startDate).format("YYYY-MM-DD")
  const placeholderTextIsEnabled = input.dataset?.enable_placeholder_text
  const datePickerSettings = {
    container: "#scroll-container",
    locale: localeEn,
    view: "days",
    autoClose: true,
    startDate: startDate,
    altField: altField,
    altFieldDateFormat: altFieldDateFormat,
    dateFormat: fieldDateFormat,
    selectedDates: [startDate],
    showOtherMonths: false,
    position({ $datepicker, $target, $pointer, done }) {
      let popper = createPopper($target, $datepicker, {
        placement: "top",
        modifiers: [
          {
            name: "flip",
            options: {
              padding: {
                top: 64,
              },
            },
          },
          {
            name: "offset",
            options: {
              offset: [0, 20],
            },
          },
          {
            name: "arrow",
            options: {
              element: $pointer,
            },
          },
        ],
      })

      return function completeHide() {
        popper.destroy()
        done()
      }
    },

    onRenderCell({ date, cellType }) {
      // Disable all 12th dates in month
      if (cellType === "day") {
        let dayName = getDayName(date)
        let today = new Date()
        if (bookingType == ACCOMMODATION) {
          if (!allowedCheckinDays.includes(dayName) || date < today) {
            return {
              disabled: true,
              classes: "disabled-class",
              attrs: {
                title: "Can't check-in on " + dayName + "s for Accommodation",
              },
            }
          }
        }
        if (bookingType == CAMPING) {
          if (date < today) {
            return {
              disabled: true,
              classes: "disabled-class",
              attrs: {
                title: "",
              },
            }
          }
        }
      }
    },
    onSelect({ date, formattedDate, datepicker }) {
      if (bookingType == ACCOMMODATION) {
        updateNightsSelectorAccommodation()
      }
      if (bookingType == CAMPING) {
        updateNightsSelectorCamping()
      }
    },
  }

  if (placeholderTextIsEnabled === "false") {
    datePickerSettings.selectedDates = [startDate]
  }

  if (AirDatepicker) {
    datePickerInstance = new AirDatepicker(field, datePickerSettings)
  }
}

function getDayName(date) {
  return date.toLocaleString("en-us", { weekday: "long" })
}
